module.exports = "pegasus_template/assets/themelp1/tickets/100.png";